(function () {
    'use strict';

    /**
     * @ngdoc service
     *
     * @description
     *
     */
    angular
        .module('salesTarget')
        .service('salesTargetService', salesTargetService);

    function salesTargetService(RemoteService) {

    	 var self = this;

         var model={
            rolesList:[]
        };

         var component = {categoryLabel:'childElements', uniqueField: 'valueFieldName'}


         self.getcomponent = function(){
        	 return component;
         };


      self.getSalesTargetResponse = function(successFn, errorFn){
        RemoteService.getSalesTarget().then(
          function (response) {
            if(response.success){
              successFn(response);
            }
          },
          function (error) {
            errorFn(error.msg[0]);
          }
        );
      };



    }
})();
